<template>
  <div>
    <div class="right-title">
      <span>新闻资讯</span>
    </div>
    <div class="content-box">
      <div class="search-box">
        <!--        <el-input-->
        <!--          class="search"-->
        <!--          type="text"-->
        <!--          placeholder="请输入职位ID/名称"-->
        <!--          v-model="search"-->
        <!--        >-->
        <!--        </el-input>-->
        <el-button class="btn2 " :class="{active:type===0}" @click="keyWord" type="primary">已发布</el-button>
        <el-button class="btn2 " :class="{active:type===2}" @click="keyWord2" type="primary">草稿</el-button>
      </div>
      <div class="tab-box">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;height: 100%"
          :header-cell-style="{background: '#f2f3f5',colori: '#000;'}"
        >
          <el-table-column
            prop="id"
            label="ID"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="title"
            label="新闻标题"
            align="center"
          >
            <template slot-scope="scope">
              <span style="color: #00a2ea;cursor: pointer;"
                    @click="toEdit(scope.row.id)">{{scope.row.title}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="发布时间"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.create_time}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="编辑"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color: #00a2ea;cursor: pointer;" @click="toEdit(scope.row.id)">编辑</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="删除"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color: #d50000;cursor: pointer;" @click="toDel(scope.row.id)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-box">
          <div></div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    data() {
      return {
        search: '',  // 搜索
        tableData: [],
        type:0,   //  0 正常 2 草稿
        page: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 1
        },
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      },

    },
    created() {
      this.$emit('setType', 0)
      this.newsList()
    },
    methods: {
      toEdit(id) {
        this.$router.push({
          path: '/home/newsAdmin/newsEdit',
          query: {
            id: id
          }
        })
      },
      // 职位列表
      newsList() {
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        if (this.$route.query.type) {
          this.type = Number(this.$route.query.type)
        } else {
          this.type = 0
        }
        this.$api.apiContent.getNewList({
          type: this.type,
          page: this.page.pageNum,
          pageSize: this.page.pageSize,
          admin_id: this.user.id,
        }).then(res => {
          loading.close();
          this.page.pageNum = res.now_page
          this.page.pageTotal = res.total_number
          res.data.map(item => {
            item.create_time = this.$tools.ZHDate(new Date(item.create_time * 1000), 1)
          })
          this.tableData = res.data
        }).catch(() => {
          loading.close();
          this.tableData = []
          this.page.pageTotal = 0
        })

      },
      keyWord() {     //  搜索
        this.type = 0
        if (this.page.pageNum === 1) {
          this.setPath()
        } else {
          this.page.pageNum = 1
        }
      },
      keyWord2() {     //  搜索
        this.type = 2
        if (this.page.pageNum === 1) {
          this.setPath()
        } else {
          this.page.pageNum = 1
        }
      },
      handleSizeChange(num) {        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num) {     //  选择页数
        this.page.pageNum = num
      },

      //  修改路径
      setPath() {
        this.$router.push({
          path: '/home/newsAdmin/newsList',
          query: {
            pageNum: this.page.pageNum,
            type: this.type
          }
        })
      },

      //  删除选中的
      toDel(id) {
        this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.newDelete({
            id: id,
            adminId: this.user.id
          }).then(res => {
            if (this.page.pageNum > 1 && this.list.length > 1) {
              this.page.pageNum = this.page.pageNum - 1
            } else {
              this.newsList()
            }
            this.$message({
              type: 'success',
              message: res.info
            });
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch();

      },

    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      $route() {
        this.newsList()
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;


    .search {
      width: 220px;
      position: absolute;
      right: 80px;
      border-radius: 4px !important;
    }

    .btn {
      position: absolute;
      left: 0px;
      padding: 10px 40px;
    }
  }

  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 50px;
    padding-bottom: 60px;
    background: #fff;


    .page-box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .btn2{
    background: #fff;
    color: #00a2ea;
  }
  .btn2.active{
    background: #00a2ea;
    color: #fff;
  }
</style>